module.exports = __webpack_public_path__ + "static/img/statistics.f63806c8.png";